export default {
  // 品牌升级通知条是否显示
  brandUpgradeNoticeVisible: (state) => state.brandUpgradeNoticeVisible,
}
